export function KeyIcon({ className }: { className?: string }) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.5002 8.33333H10.5418C9.8585 6.39167 8.0085 5 5.8335 5C3.07516 5 0.833496 7.24167 0.833496 10C0.833496 12.7583 3.07516 15 5.8335 15C8.0085 15 9.8585 13.6083 10.5418 11.6667H10.8335L12.5002 13.3333L14.1668 11.6667L15.8335 13.3333L19.1668 9.96667L17.5002 8.33333ZM5.8335 12.5C4.4585 12.5 3.3335 11.375 3.3335 10C3.3335 8.625 4.4585 7.5 5.8335 7.5C7.2085 7.5 8.3335 8.625 8.3335 10C8.3335 11.375 7.2085 12.5 5.8335 12.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
